import React from "react";
import DangerIcon from "../../../../assets/icons/danger";
import Globe from "../../../../assets/icons/Globe";

interface GeneratePaymentPromptProps {
  onClose?: () => void;
}
const PaymentLinkUnavailable: React.FC<GeneratePaymentPromptProps> = ({
  onClose,
}) => {
  return (
    <>
      <div className="md:p-8 p-4 bg-[#ffffff] rounded-[16px] min-w-[340px] max-w-[400px] md:max-w-[520px] overflow-y-auto">
        <div className="flex flex-col justify-center items-center text-center">
          <Globe />
          <h1 className="xl:text-[24px] biglg:text-[24px] 2xl:text-[24px] lg:text-[20px] text-[16px] md:text-[18px] font-semibold mt-[0.6em]">
            Payment Link Unavailable
          </h1>

          <p className="hidden lg:block md:block font-medium text-center text-[#475467] mt-[1em] text-[14px] md:text-[16px]">
          This feature isn’t available in your region at the moment. We’re working to expand access globally. Stay tuned!
          </p>
          <p className="lg:hidden md:hidden font-medium text-center text-[#475467] mt-[1em] text-[14px] md:text-[16px] px-2">
          This feature isn’t available in your region at the moment. We’re working to expand access globally. Stay tuned!
          </p>
        </div>
        <div className="flex justify-center gap-8 mt-6 text-[10px] md:text-[14px]">
          <button
            className="border border-[#044E97] font-medium text-[#ffffff] bg-[#044E97] text-[16px] py-2 h-12 px-[2.5em] rounded"
            onClick={onClose}
          >
            Got it
          </button>
        </div>
      </div>
    </>
  );
};

export { PaymentLinkUnavailable };
